import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['button', 'answer', 'plus']

  toggleAnswer() {
    this.answerTarget.classList.toggle('faq-answer--active')
    this.plusTarget.classList.toggle('rotate-45')
  }
}